import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";

const StoreInviteAcceptPage = lazy(() => import("./pages/StoreInviteAcceptPage").then(module => ({ default: module.StoreInviteAcceptPage })));

export const teamRoutes: RouteObject[] = [
  {
    path: "store-invite/:token",
    element: <RouteSuspense><StoreInviteAcceptPage /></RouteSuspense>,
  },
];
